/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPlus } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../../environment';
import Loading from '../../components/Loading';

import * as customersService from '../../services/customers';

import stylesLayout from '../../common/layout.module.scss';
import CustomersTable from '../../components/CustomersTable';

const CustomersModule = (
) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);

  const loadCustomers = async () => {
    setLoading(true);
    console.log('load');
    const rsp = await customersService.all();
    console.log('rsp', rsp);
    if (rsp && rsp.status) {
      setCustomers(rsp.data);
    }
    setLoading(false);
  };

  const onAction = (action, hash) => {
    switch (action) {
      case 'view':
        history.push(`/cliente/${hash}`);
        break;
      default:
    }
  };

  useEffect(() => {
    loadCustomers();
  }, []);

  if (loading) {
    return <div className={stylesLayout.page}><Loading /></div>;
  }

  // const stepsStore = getStepsStore(store);
  // const pendingStepsStore = (stepsStore.filter((x) => !x.completed));
  return (
    <div className={stylesLayout.page}>
      <div className={stylesLayout.title}>
        Clientes
        <div className={stylesLayout.secAction}>
          <CSVLink
            filename="clientes.csv"
            data={customers.map((e) => ({
              nombre: e.name,
              email: e.email,
              telefono: e.phone,
              nacimiento: e.birthdate ? moment(e.birthdate).format('YYYY-MM-DD') : '',
              sol: e.sun,
              luna: e.moon,
              ascendente: e.ascendant,
            }))}
          >
            <Button type="secondary">
              <FontAwesomeIcon icon={faDownload} style={{ marginRight: 5 }} />
              Exportar como CSV

            </Button>
          </CSVLink>
          {' '}
          <Button onClick={() => {
            window.open(`${API_BASE_URL}/customers/xlsx?token=${localStorage.getItem('token')}`);
          }}
          >
            <FontAwesomeIcon icon={faDownload} style={{ marginRight: 10 }} />
            Exportar como Excel

          </Button>
          {' '}
          <Button onClick={() => { history.push('/cliente/nueva'); }}>
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: 10 }} />
            Agregar
          </Button>
        </div>
      </div>
      <div className={stylesLayout.content}>
        <CustomersTable
          items={customers}
          onAction={onAction}
        />
      </div>
    </div>
  );
};

CustomersModule.propTypes = {
};

export default CustomersModule;
